import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center items-center h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Gallery is currently unavailable. Please try again later. ", -1)
const _hoisted_4 = [
  _hoisted_3
]

import { computed, onMounted, PropType, ref } from 'vue';
import { Inspection } from '@/entities/inspection/types';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryWorkspace',
  props: {
  inspectionId: {
    type: Number as PropType<Inspection['id']>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const isError = ref(false);
const frame = ref();
const iFrameDestination = process.env.VUE_APP_GALLERY;
const urlDestination = computed(() => `${ iFrameDestination }/${ props.inspectionId }`);

onMounted(async () => {
  try {
    if (!iFrameDestination) {
      console.error(`The IFrame destination must be instantiated : ${iFrameDestination}`);
      isError.value = true;
      return;
    }

    const response = await axios.get(iFrameDestination);

    if ( response.status !== 200 ) {
      console.error(response.status);
      isError.value = true;
      return;
    }

    const token = JSON.parse(localStorage.getItem(`auth-tokens-${ process.env.NODE_ENV }`)!);
    frame.value.onload = () => {
      frame.value.contentWindow.postMessage(token, iFrameDestination);
    };
    console.log('Content loaded');
  } catch (e) {
    isError.value = true;
    console.error(e);
  }
});

return (_ctx: any,_cache: any) => {
  return (!isError.value)
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "frame",
        ref: frame,
        src: _unref(urlDestination),
        title: "gallery",
        width: "100%",
        height: "100%"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}
}

})